import api from "./../utils/api";

export const testTelegramOrderMessage = async () => {
  try {
    const response = await api.post(
      "/telegram/test-order-message",
      {},
      {
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
